module.exports = __webpack_public_path__ + "static/img/slider-55.6248606.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slider-55.jpg
// module id = lx2Q
// module chunks = 0